import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import { IconButtonV2 } from 'components/common/ui';
import { useToggleModal } from '@hooks';
import { showError } from '@utils';
import { boardsServices } from '@services';

import { PermissionsGate } from 'components/common';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import { Tooltip } from 'components/common/modals';
import { AddBillingTaskModal } from './AddBillingTaskModal';

const AddBillingTask = ({ boardId, assignees, statuses, onGetTasks }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, handleClose, handleOpen } = useToggleModal();

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);

      await boardsServices.addTask(boardId, {
        tags: [],
        ...values,
        assignee: values.assignee.value,
        status: Number(values.status.value),
      });

      await onGetTasks();

      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PermissionsGate entity={ENTITIES_PERMISIONS.WriteBillingTickets}>
        <IconButtonV2 onClick={handleOpen} variant="text" size="small">
          <Tooltip title="Add Ticket" placement="top">
            <AddIcon data-testid="AddIcon" fontSize="small" />
          </Tooltip>
        </IconButtonV2>
      </PermissionsGate>

      {isOpen && (
        <AddBillingTaskModal
          isOpen={isOpen}
          isLoading={isLoading}
          assignees={assignees}
          statuses={statuses}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default AddBillingTask;
